import flatten from 'lodash/flatten';
import every from 'lodash/every';

import { NY_DESSERT, NY_DISHES } from 'app/utils/filters';

export const nyPeriod = '2025-12-29';

export const periods = [
    '2026-12-29',
    // Регионы
    '2026-12-30',
];
export const beforeNYRegionPeriodStart = '2025-12-23';
export const NYPeriodStart = '2025-12-29';
export const NYPeriodStartRegions = '2025-12-30';
export const NYPeriodEnd = '2025-12-31';
export const allNYPeriods = [
    '2025-12-29',
    '2025-12-30',
    '2026-01-04',
];
export const allNYDeliveryDates = [
    '2025-12-29',
    '2025-12-30',
    '2025-12-31',
];

export const nyPeriodsDates = {
    '2025-12-29': ['2025-12-29', '2025-12-30', '2025-12-31'],
    '2025-12-30': ['2025-12-30', '2025-12-31'],
};

export const extraPeriodNYStart = '2026-01-04';
export const extraPeriodNYEnd = '2026-01-05';

export const extraPeriodNyDates = {
    '2026-01-04': ['2026-01-04', '2026-01-05'],
};

export const pastNyUnavailableDates = [
    '2025-01-01',
    '2025-01-02',
    '2025-01-03',
];

export const enabledDishes = {
    // наборы на черном фоне
    set: [
        '4702',
        '4705',
        '4703',
        '3433',
    ],
    // остальное на белом фоне
    main: [
        '2750',
        '2751',
        '5554',
        '5158',
        '4697',
    ],
    salads: [
        '3839',
        '5159',
        '5552',
        '3433',
        '57',
        '5152',
        '4701',
        '5553',
    ],
    dessert: [
        '5549',
        '5550',
        '1257',
        '3834',
        '5551',
        '2744',
    ],
    drinks: [
        '5154',
        '5155',
    ],
    niceStuff: [
        '3433',
        '9',
        '172',
        '364',
        '1258',
        '3386',
        '2561',
    ],
    sauсes: [
        '4812',
        '4815',
        '4813',
        '4814',
    ],
    gifts: [
        '3889',
        '3890',
    ],
    delicacies: [],
};

export const dessertHP = [

];

export const nyMenuDishWithLabel = [

];

export const availableBasketDishIds = flatten(Object.values(enabledDishes));


/**
 * @param {string[]} basketDishesIds - An array of dish ID in the basket.
 * @return {string[]} An array of NY invoice tags.
 */
export function getInvoiceTags(basketDishesIds) {
    const isEveryDishIsDessert = every(
        basketDishesIds,
        (basketDishId) => enabledDishes.dessert.includes(basketDishId),
    );
    const isEveryDishIsNotDessert = every(
        basketDishesIds,
        (basketDishId) => !enabledDishes.dessert.includes(basketDishId),
    );
    if (isEveryDishIsDessert) {
        return [NY_DESSERT];
    }
    if (isEveryDishIsNotDessert) {
        return [NY_DISHES];
    }
    return [NY_DISHES, NY_DESSERT];
}
